// extracted by mini-css-extract-plugin
module.exports = {"link-list-component":"LinkList_link-list-component__mZ7k9"};